// Get a reference to the input element
const inputElements = document.querySelectorAll('.format');

// Function to format the input with commas
function formatInputWithCommas(inputValue) {
    // Remove existing commas and non-digit characters
    const cleanValue = inputValue.replace(/\D/g, '');

    // Add commas every three digits from the right
    return cleanValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

// Function to update the input value on input event
function handleInput(event) {
    event.target.value = formatInputWithCommas(event.target.value);
}

inputElements.forEach(inputElement => {
    // Attach the handleInput function to the input event
    inputElement.addEventListener('input', handleInput);
})


const priceForms = document.querySelectorAll('.price_form');

priceForms.forEach(priceForm => {
    const minPriceInput = priceForm.querySelector('.min_price');
    const maxPriceInput = priceForm.querySelector('.max_price');

    priceForm.addEventListener('submit', function (event) {
        const minPrice = Number(minPriceInput.value.replaceAll(", ", ""));
        const maxPrice = Number(maxPriceInput.value.replaceAll(", ", ""));

        if (maxPrice > 100000000000 || minPrice > 100000000000 || isNaN(maxPrice) || isNaN(minPrice)) {
            alert("Nous n'avons aucune propriétés avec cet intervalle de prix. Veuillez réajuster");
            event.preventDefault();
        }
        if (minPrice >= maxPrice) {
            alert('Le prix minimal ne peut être égal ou supérieur au prix maximal!');
            event.preventDefault();
        }
    });
});

// Hide success or error notification on contact form
document.addEventListener("htmx:load", () => {
    const errorNotification = document.getElementById('error-notification');
    const successNotification = document.getElementById('success-notification');

    const hideNotification = (element) => {
    setTimeout(() => {
        element.classList.add('closed-notif');
        setTimeout(() => {
            element.style.display = 'none';
        }, 2000); // for the CSS transition (1s)
    }, 15000); // 15 seconds

    };

    if (errorNotification) {
        hideNotification(errorNotification);
    }

    if (successNotification) {
        hideNotification(successNotification);
    }

});

// Make page to load on the top when clicking "Next" or "Previous"
// on the pagination buttons in the listing page.
document.addEventListener('htmx:afterSwap', function(evt) {
    if (evt.detail.target.id === 'ads') {
        window.scrollTo(0, 0);
    }
});

const LG_SCREEN_SIZE = 1200
const MD_SCREEN_SIZE = 768

export function isHomePage() {
    // Check if current page is Home Page
    return window.location.pathname.includes("/home");
}

export function isAdListingPage() {
    // Check if current page is "ads listing page" and "not favorites ads page"
    const pathname = window.location.pathname
    const isAdListingPage = pathname.includes("/annonces-immobilieres") || (pathname.includes("/ad/listing") && !pathname.includes("/ad/listing/favorites/"))
    return isAdListingPage;
}

export function isAdAlertPage() {
    // Check if current page is Ad Alert Page
    return window.location.pathname.includes("/ad/alerts/") && window.location.pathname !== "/ad/alerts/";
}

export function isMyAdsPage() {
    // Check if current page is Ad Alert Page
    return window.location.pathname.includes("/ad/my-ads");
}

export function isAdDetailsPage() {
    // Check if current page is Ad Alert Page
    return window.location.pathname.includes("/ad/details/");
}

export function initSearchInputInteractions(e) {
    // Manage search input interactions on hero section

    if (isHomePage()) {

        const homeSearch = document.querySelector('#home-search');
        const searchButton = document.querySelector('#search-button');
        const currentLocationDiv = document.querySelector('#current-location');
        const svgIcon = searchButton.querySelector('svg path');

        homeSearch.addEventListener('input', () => {
            if (homeSearch.value.trim() !== "") {
                searchButton.removeAttribute('disabled');
                currentLocationDiv.classList.remove('opacity-0');
                currentLocationDiv.classList.remove('pointer-events-none');
                svgIcon.setAttribute('fill', 'white');
            } else {
                searchButton.setAttribute('disabled', 'true');
                currentLocationDiv.classList.add('opacity-0');
                currentLocationDiv.classList.add('pointer-events-none');
                svgIcon.setAttribute('fill', '#BCBCBC');
            }
        });
    }
}

function updatePlaceholder() {
    // Change placeholder text on hero section search input depending of screen size

    if (isHomePage()) {
        const input = document.getElementById('home-search');

        // Get translated placeholder texts from data attributes
        const placeholderSm = input.getAttribute('data-placeholder-sm');
        const placeholderMd = input.getAttribute('data-placeholder-md');
        const placeholderLg = input.getAttribute('data-placeholder-lg');

        if (window.innerWidth <= MD_SCREEN_SIZE) {
            input.placeholder = placeholderSm;
        } else if (window.innerWidth <= LG_SCREEN_SIZE) {
            input.placeholder = placeholderMd;
        } else {
            input.placeholder = placeholderLg;
        }
    }
}

function initializeHomePage() {
    // Initialize some home page functions

    initSearchInputInteractions();
    updatePlaceholder();
};

window.addEventListener('resize', updatePlaceholder);
window.addEventListener('load', initializeHomePage);

function initializeAdListingPage() {
    if (isAdListingPage() || isAdAlertPage()) {
        document.addEventListener('htmx:beforeRequest', function() {
            document.getElementById('reset-spinner').classList.add('animate-spin-custom');
        });
        document.addEventListener('htmx:afterRequest', function() {
            document.getElementById('reset-spinner').classList.remove('animate-spin-custom');
        });
    }
}

initializeAdListingPage();

function initializeAdDetailsPage() {
    if (isAdDetailsPage()) {
        // Deactivate for mobile
        if (window.matchMedia('(max-width: 767px)').matches) return null;

        const scrollContainer = document.getElementById('images-scroll-container');
        const scrollLeftBtn = document.getElementById('images-scroll-left');
        const scrollRightBtn = document.getElementById('images-scroll-right');
        const adDetailsImageWidth = scrollContainer.getAttribute('data-ad-details-image-width')
        const scrollAmount = scrollContainer.clientWidth * adDetailsImageWidth / 100; // Pixels to scroll on each click
        let distanceToScroll = scrollAmount

        const updateScrollButtons = () => {
            if (scrollLeftBtn) scrollLeftBtn.disabled = scrollContainer.scrollLeft <= 0;
            if (scrollRightBtn) scrollRightBtn.disabled = scrollContainer.scrollLeft + scrollContainer.clientWidth + 10 >= scrollContainer.scrollWidth;
        };

        if (scrollLeftBtn) {
            scrollLeftBtn.addEventListener('click', () => {
                // Uncomment if you need to scroll two case per click
                /*
                if (scrollContainer.scrollLeft == scrollAmount * 2) {
                    distanceToScroll = scrollAmount * 2
                }
                */
                scrollContainer.scrollBy({ left: -distanceToScroll, behavior: 'smooth' });
            });
        }

        if (scrollRightBtn) {
            scrollRightBtn.addEventListener('click', () => {
                // Uncomment if you need to scroll two case per click
                /*
                if (scrollContainer.scrollLeft <= 0) {
                    distanceToScroll = scrollAmount * 2
                }
                */
                scrollContainer.scrollBy({ left: distanceToScroll, behavior: 'smooth' });
            });
        }

        scrollContainer.addEventListener('scroll', updateScrollButtons);
        updateScrollButtons(); // Initialize button states on load
    }
}

document.addEventListener('DOMContentLoaded', () => {
    initializeAdDetailsPage();
});

window.addEventListener('resize', initializeAdDetailsPage);